import {
  ITransaction,
  TransactionStatus,
} from "@/apps/credit-line/models/CreditLineDetails";
import { reactive, watchEffect } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export interface ITransactionButtonDetails {
  isGreyOut: boolean;
  reasonForGreyOut: string;
}

export interface ITransactionButton {
  transactionBtn: ITransactionButtonDetails;
}

export function useReportTransactionButton(
  inputTransaction: ITransaction | null
): ITransactionButton {
  const { t } = useI18n();
  const transactionBtn = reactive<ITransactionButtonDetails>({
    isGreyOut: false,
    reasonForGreyOut: "",
  });

  const isTransactionOlderThan120Days = (
    transaction: ITransaction
  ): boolean => {
    const transactionDate = new Date(transaction.date * 1000);
    const currentDate = new Date();

    const transactionUTC = Date.UTC(
      transactionDate.getUTCFullYear(),
      transactionDate.getUTCMonth(),
      transactionDate.getUTCDate()
    );

    const currentUTC = Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getUTCDate()
    );

    const daysDifference = Math.abs(
      Math.floor((currentUTC - transactionUTC) / (1000 * 60 * 60 * 24))
    );
    return daysDifference > 120;
  };

  const transactionHasStatus = (
    transaction: ITransaction,
    expectedStatus: TransactionStatus
  ): boolean => {
    return transaction.status === expectedStatus;
  };

  watchEffect(() => {
    if (!inputTransaction) return;

    const isRejected = transactionHasStatus(
      inputTransaction,
      TransactionStatus.REJECTED
    );
    const isExpired = transactionHasStatus(
      inputTransaction,
      TransactionStatus.EXPIRED
    );
    const isOlderThan120Days = isTransactionOlderThan120Days(inputTransaction);

    transactionBtn.reasonForGreyOut = isOlderThan120Days
      ? t("CL_TRANSACTIONS.TRANSACTION_OLDER_THAN_120_DAYS")
      : isRejected || isExpired
      ? t("CL_TRANSACTIONS.TRANSACTION_REJECTED_OR_EXPIRED")
      : "";
    transactionBtn.isGreyOut = isRejected || isOlderThan120Days || isExpired;
  });

  return {
    transactionBtn,
  };
}
